import React from 'react'
// context
import { RiskViewContext } from 'containers/Risks/RiskView/Risk/layers'
// views
import { Chip, RecurrenceFieldWrapper } from './views'
// themes
import { colors } from 'themes/index'
// utils
import moment from 'moment/moment'
import { get } from 'lodash'
import { generateRecurrenceLabel } from 'utils/kpi'

const RecurrenceColumns: React.FC = () => {
  const { risk } = React.useContext(RiskViewContext)

  const isRecurrenceActive = get(risk, 'recurrence.active', false)

  return (
    <>
      <RecurrenceFieldWrapper>
        {risk.recurrence && Object.keys(risk.recurrence).length > 1 ? generateRecurrenceLabel(risk.recurrence) : 'N/A'}
      </RecurrenceFieldWrapper>
      <RecurrenceFieldWrapper>
        {risk.startOfTheNextPeriodAt ? moment(risk.startOfTheNextPeriodAt).format('D MMMM YYYY') : 'N/A'}
      </RecurrenceFieldWrapper>
      <RecurrenceFieldWrapper>
        <Chip
          label={isRecurrenceActive ? 'Active' : 'Inactive'}
          color={isRecurrenceActive ? colors.green300 : colors.red200}
        />
      </RecurrenceFieldWrapper>
    </>
  )
}

export default RecurrenceColumns
